// Match Shopify's money placeholders without depending on the page language.
window.FPMoney = window.FPMoney || {
  format(cents, format = 'R$ {{amount_with_comma_separator}}') {
    const value = Math.abs(Number(cents) || 0);
    const decimal = (value / 100).toFixed(2);
    const whole = String(Math.round(value / 100));
    const group = (digits, separator) => digits.replace(/\B(?=(\d{3})+(?!\d))/g, separator);
    const [integer, fraction] = decimal.split('.');
    const amounts = {
      amount: `${group(integer, ',')}.${fraction}`,
      amount_with_comma_separator: `${group(integer, '.')},${fraction}`,
      amount_with_apostrophe_separator: `${group(integer, "'")}.${fraction}`,
      amount_no_decimals: group(whole, ','),
      amount_no_decimals_with_comma_separator: group(whole, '.'),
    };
    return format.replace(/\{\{\s*(\w+)\s*\}\}/g, (match, key) => amounts[key] ?? match);
  },
};
